import React from 'react';
import SwitchButton from 'react-switch';
import { TOGGLE_ON_COLOR } from '../../../constants';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonTable from '../../CommonTable/CommonTable';
import { updatePaymentGatewayStatus } from '../../../actions/siteadmin/updatePayemntGatewayStatus';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import messages from '../../../locale/jsonMessages';
import s from './ManagePaymentGateway.css';
import paypalLogo from '/public/PaymentGateway/paypal.svg';
import stripeLogo from '/public/PaymentGateway/stripe.svg';
import pawapayLogo from '/public/PaymentGateway/pawapay.svg';
import { logouploadDir } from '../../../config';
import { photosShow } from '../../../helpers/photosShow';
export class ManagePaymentGateway extends React.Component {
    static propTypes = {
        getAllPayments: PropTypes.shape({
            loading: PropTypes.bool,
            refetch: PropTypes.any.isRequired,
            getAllPaymentMethods: PropTypes.array
        }),
        title: PropTypes.string.isRequired,
    };

    state = { saving: false };

    async handleUpdate(id, changes) {
        const { updatePaymentGatewayStatus, getAllPayments: { refetch }, demoRestriction } = this.props;
        if (this.state.saving) return;
        this.setState({ saving: true });
        try {
            if (await demoRestriction({})) return;
            await updatePaymentGatewayStatus(id, changes);
            await refetch();
        } finally {
            this.setState({ saving: false });
        }
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        return [
            { data: formatMessage(messages.gatewayId) },
            { data: formatMessage(messages.paymentGateway) },
            { data: formatMessage(messages.gatewayCheckout) },
            { data: formatMessage(messages.gatewayPayout) },
            { data: formatMessage(messages.gatewayEnvironment) },
            { data: formatMessage(messages.gatewayGlobalStatus) },
            { data: formatMessage(messages.gatewayActions) }
        ]
    };

    tbody = (props) => {
        const { getAllPayments: { getAllPaymentMethods } } = props;
        const { formatMessage } = this.props.intl;

        const gateways = {
            1: { key: 'paypal', logo: paypalLogo },
            2: { key: 'stripe', logo: stripeLogo },
            3: { key: 'pawapay', logo: pawapayLogo }
        };
        return getAllPaymentMethods?.map(value => {
            const gateway = gateways[Number(value.id)] || {};
            return {
                id: value?.id,
                data: [
                    { data: value?.id },
                    {
                        data: <span className={s.gatewayName}>
                            <img
                                className={s.gatewayLogo}
                                src={value.logo ? photosShow(logouploadDir) + value.logo : gateway.logo}
                                alt=""
                                onError={event => {
                                    if (event.currentTarget.src !== gateway.logo) event.currentTarget.src = gateway.logo;
                                }}
                            />
                            {value?.paymentName}
                        </span>
                    },
                    ...['checkoutEnabled', 'payoutEnabled'].map(field => ({
                        data: <label className={s.operation}>
                            <SwitchButton height={20} width={36} checkedIcon={false} uncheckedIcon={false} onColor={TOGGLE_ON_COLOR}
                                aria-label={`${value.paymentName} ${field === 'checkoutEnabled' ? 'Checkout' : 'Payout'}`}
                                checked={Boolean(value[field])} disabled={this.state.saving}
                                onChange={checked => this.handleUpdate(value.id, { [field]: checked })} />
                            {' '}{formatMessage(value[field] ? messages.activeLabel : messages.inActiveLabel)}
                        </label>
                    })),
                    { data: formatMessage(value.configurationEnvironment === 'sandbox' || value.configurationEnvironment === 'test' ? messages.sandboxLabel : messages.productionLabel) },
                    {
                        data: <select className='commonTableInsideSelect' value={value.isEnable}
                            aria-label={`${value.paymentName} ${formatMessage(messages.status)}`}
                            disabled={this.state.saving}
                            onChange={e => this.handleUpdate(value.id, { isEnable: e.target.value === 'true' })}>
                            <option value={true} disabled={!value.checkoutEnabled && !value.payoutEnabled}>{formatMessage(messages.activeLabel)}</option>
                            <option value={false}>{formatMessage(messages.inActiveLabel)}</option>
                        </select>
                    },
                    {
                        data: gateway.key && <a className={s.configure} href={`/siteadmin/payment-gateway-section/${gateway.key}/config`}>
                            {formatMessage(messages.gatewayConfigure)}
                        </a>
                    },
                ]
            }
        })
    }

    render() {
        const { formatMessage } = this.props.intl;

        return (
            <CommonTable
                className={s.gatewayTable}
                thead={this.thead}
                tbody={() => this.tbody(this.props)}
                title={formatMessage(messages.managePaymentGateWay)}
            />
        )
    }

}

const mapState = (state) => ({});

const mapDispatch = {
    updatePaymentGatewayStatus,
    demoRestriction
};

export default compose(injectIntl, withStyles(s), connect(mapState, mapDispatch))(ManagePaymentGateway);
